/* eslint-disable max-len */
import {
  takeLatest,
  select,
  put,
  putResolve,
  all
} from 'redux-saga/effects';
import forEach from 'lodash/forEach';
import find from 'lodash/find';
import get from 'lodash/get';
import {
  dismissLoading,
  updateSelectedChoice,
  persistDesign,
} from '../actions/actionCreators';
import {
  addRoomMeasure
} from '../actions';
import {
  configuratorChoices,
  configuratorOptions,
  configuratorProductInfo
} from '../selectors/configurator';
import { currentItemSelector } from '../selectors/design/currentItem';
import safeSaga from './safeSaga';

// 'Select Carpet' is fallback, 'Color/Finish' is SuperSku
const isCarpetChoice = (optionName) => optionName === 'Select Carpet' || optionName === 'Color/Finish';
const isOmsidChoice = (optionName) => optionName === 'OMSID';
const isCarpetPadChoice = (optionName) => optionName === 'Carpet Padding';

function* loadSelectionsFromDesign() {
  try {
    const optionsFromConfigurator = yield select(configuratorOptions);
    const choicesFromConfigurator = yield select(configuratorChoices);
    const multiSelectOption = find(optionsFromConfigurator, (ch) => ch?.tags && ch.tags.includes('multi-choice-group'));
    const multiSelectChoice = find(choicesFromConfigurator, (ch) => ch?.tags && ch.tags.includes('multi-choice-values'));
    // currentItem (which has the selected design choices) comes from design api
    const { itemProduct: { choices } } = yield select(currentItemSelector);
    const selectedCarpetChoice = find(choices, (ch) => isCarpetChoice(ch.optionName));
    const selectedOmsidChoice = find(choices, (ch) => isOmsidChoice(ch.optionName));
    const selectedCarpetPadding = find(choices, (ch) => isCarpetPadChoice(ch.optionName));
    const selectedCarpetPaddingChoice = choicesFromConfigurator[selectedCarpetPadding.choiceId];
    // additional details (which has all the room measure and steps info) comes from configurator api
    const productInfo = yield select(configuratorProductInfo);
    // TODO: there has to be a check here and fires and error.
    const { measures: { measure }, steps } = JSON.parse(productInfo.additionalDetails);

    // rooms
    const roomActions = measure.map((item) => put(addRoomMeasure(item)));
    yield all(roomActions);
    // steps
    if (steps.steps > 0) {
      yield all([
        put({ type: 'UPDATE_STEPS', payload: steps }),
        put({ type: 'CONFIRM_STEPS', payload: true }),
        put({ type: 'QUESTION_ANSWERED', payload: true })
      ]);
    } else {
      yield all([
        put({ type: 'QUESTION_ANSWERED', payload: true }),
        put({ type: 'ADD_STEPS', payload: false })
      ]);
    }
    // pad --> is this not persisted?

    // carpettype --> is this not persisted?
    // carpetSwatch
    yield putResolve(updateSelectedChoice({ id: selectedCarpetChoice.choiceId, sku: selectedOmsidChoice.choiceValue }));
    // colorfamilies
    if (multiSelectChoice) {
      const multiSelectChoiceId = get(multiSelectChoice, 'id');
      const multiSelectChoiceFromDesign = find(choices, { choiceId: multiSelectChoiceId });
      if (multiSelectChoiceFromDesign) {
        const multiSelectChoiceValues = get(multiSelectChoiceFromDesign, 'choiceValue').split('|');
        forEach(multiSelectOption.choices, (ch) => {
          if (multiSelectChoiceValues.includes(choicesFromConfigurator[ch].value)) {
            choicesFromConfigurator[ch] = { ...choicesFromConfigurator[ch], isMultiSelected: true };
          }
        });
        choicesFromConfigurator[multiSelectChoiceId].value = multiSelectChoiceValues.join('|');
        yield putResolve({
          type: 'INIT_GUIDED_OPTION_FILTER',
          payload: { type: 'colorFamily', colorfamily: multiSelectChoiceValues.join('|') }
        });
      }
    }

  } catch (err) {
    // eslint-disable-next-line no-console
    console.log(`Persist data saga failed: ${err.message}`);
  }
  yield putResolve(dismissLoading());
}

export function* persistSelectionsFromDesignSaga() {
  yield takeLatest(persistDesign, safeSaga(loadSelectionsFromDesign));
}
